import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { useState, useEffect } from "react";
import { Plus, Minus } from "lucide-react";
import axios from "axios";

function Drawer({ opened, noteControllerName, noteActionName }) {
  const [pageNote, setPageNote] = useState(null);
  const [comments, setComments] = useState([]);
  useEffect(() => {
    axios
      .get(`/system/page_notes/${noteControllerName}/${noteActionName}`)
      .then(({ data }) => setPageNote(data));
  }, [noteControllerName, noteActionName]);

  return (
    <div
      style={{
        zIndex: 999,
        width: "60vw",
        right: "50px",
        top: "20px",
        height: "calc(100vh - 80px)",
        transform: opened ? "scale(1)" : "scale(0)",
        transformOrigin: "bottom right",
        transition: "transform 0.2s ease-out",
      }}
      className="z-[99] fixed bg-white shadow-lg rounded-lg ring-1 ring-slate-300"
    >
      <div className="h-full overflow-y-auto p-4"></div>
    </div>
  );
}

function PageCommentsButton({ onClick, opened }) {
  const Icon = opened ? Minus : Plus;

  return (
    <button
      onClick={onClick}
      style={{
        zIndex: 1000,
        height: "60px",
        width: "60px",
        bottom: "20px",
        right: "20px",
      }}
      className="fixed bottom-4 right-4 bg-default-600 text-white w-12 h-12 rounded-lg shadow ring-1 ring-default-700 flex items-center justify-center z-10"
    >
      <Icon />
    </button>
  );
}

function PageComments({ noteControllerName, noteActionName }) {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        opened={opened}
        noteControllerName={noteControllerName}
        noteActionName={noteActionName}
      />
      <PageCommentsButton onClick={() => setOpened(!opened)} opened={opened} />
    </>
  );
}

export default class extends Controller {
  connect() {
    this.root = createRoot(this.element);
    const { noteControllerName, noteActionName } = this.element.dataset;
    this.root.render(
      <PageComments
        noteControllerName={noteControllerName}
        noteActionName={noteActionName}
      />,
    );
  }
}
